var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2539 23.75L35.0039 27.5L31.2539 31.25",
    stroke: "#333333",
    strokeWidth: 2.08928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2539 8.75L35.0039 12.5L31.2539 16.25",
    stroke: "#333333",
    strokeWidth: 2.08928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 27.5H11.6555C12.6843 27.5 13.6972 27.246 14.6044 26.7605C15.5115 26.2751 16.2847 25.5732 16.8555 24.7172L20 20",
    stroke: "#333333",
    strokeWidth: 2.08928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.4961H11.6555C12.6843 12.4961 13.6972 12.7501 14.6044 13.2356C15.5115 13.721 16.2847 14.4229 16.8555 15.2789L23.1445 24.7133C23.7153 25.5693 24.4885 26.2712 25.3956 26.7566C26.3028 27.2421 27.3157 27.4961 28.3445 27.4961H32.5",
    stroke: "#333333",
    strokeWidth: 2.08928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4961 12.4961H28.3406C27.3118 12.4961 26.2989 12.7501 25.3917 13.2356C24.4846 13.721 23.7114 14.4229 23.1406 15.2789L22.4961 16.2461",
    stroke: "#333333",
    strokeWidth: 2.08928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatch);
export default __webpack_public_path__ + "static/media/match.e51c8b5b.svg";
export { ForwardRef as ReactComponent };